import { HeaderItem } from '@root/component/table-fixed-header/table-fixed-header.component';

export const GuestListTimeOptions: Array<any> = [
  // 上次入住
  {
    label: 'guest.list.last_checkin',
    i18nKey: 'guest.list.last_checkin',
    value: 'last',
  },
  // 所有入住
  {
    label: 'guest.list.all_checkin',
    i18nKey: 'guest.list.all_checkin',
    value: 'all',
  },
  // 首次入住
  {
    label: 'guest.list.first_checkin',
    i18nKey: 'guest.list.first_checkin',
    value: 'first',
  },
];

export const listOfHeaderForGuestList: Array<HeaderItem> = [
  {
    name: '房客姓名',
    i18nName: 'guest.list.column.name',
    width: 150,
    firstColumn: true,
    column: 1,
  },
  { name: '手机号', i18nName: 'guest.list.column.mobile', width: 150, column: 2 },
  { name: '手机归属地', i18nName: 'guest.list.column.phone_area', width: 150, column: 3 },
  { name: '邮箱', i18nName: 'guest.list.column.email', width: 150, column: 4 },
  {
    name: '证件类型',
    i18nName: 'guest.list.column.id_type',
    width: 110,
    column: 5,
  },
  { name: '证件号码', i18nName: 'guest.list.column.id_number', width: 150, column: 6 },
  {
    name: '累计消费',
    i18nName: 'guest.list.column.total_consumption',
    width: 150,
    sortable: true,
    field: 'cumulative_consumer',
    column: 7,
  },
  {
    name: '入住次数',
    i18nName: 'guest.list.column.checkin_time',
    width: 150,
    sortable: true,
    field: 'checkin_times',
    column: 8,
  },
  {
    name: '订单均价',
    i18nName: 'guest.list.column.arr',
    width: 120,
    sortable: true,
    field: 'avg_reservation_price',
    column: 9,
  },
  {
    name: '间夜数',
    i18nName: 'guest.list.column.nights',
    width: 150,
    sortable: true,
    field: 'total_nights',
    column: 10,
  },
  {
    name: '间夜均价',
    i18nName: 'guest.list.column.adr',
    width: 120,
    sortable: true,
    field: 'avg_night_price',
    column: 11,
  },
  {
    name: '上次入住',
    i18nName: 'guest.list.column.last_stay',
    width: 100,
    sortable: true,
    field: 'last_checkin_time',
    column: 12,
  },
  {
    name: '首次入住',
    i18nName: 'guest.list.column.first_stay',
    width: 100,
    sortable: true,
    field: 'first_checkin_time',
    column: 13,
  },
  { name: '国籍', i18nName: 'guest.list.column.nationality', width: 150, column: 14 },
  { name: '生日', i18nName: 'guest.list.column.birthday', width: 150, column: 15 },
  { name: '备注', i18nName: 'guest.list.column.remarks', width: 150, column: 16 },
  { name: '标签', i18nName: 'word.tag', width: 200, column: 17 },
  { name: '', i18nName: '', width: 100, column: 18, hide: true },
];
export const listOfHeaderForGuestListI18n: Array<HeaderItem> = [
  {
    name: '房客姓名',
    i18nName: 'guest.list.column.name',
    width: 150,
    firstColumn: true,
    column: 1,
  },
  { name: '手机号', i18nName: 'guest.list.column.mobile', width: 150, column: 2 },
  { name: '邮箱', i18nName: 'guest.list.column.email', width: 150, column: 4 },
  {
    name: '证件类型',
    i18nName: 'guest.list.column.id_type',
    width: 110,
    column: 5,
  },
  { name: '证件号码', i18nName: 'guest.list.column.id_number', width: 150, column: 6 },
  {
    name: '累计消费',
    i18nName: 'guest.list.column.total_consumption',
    width: 150,
    sortable: true,
    field: 'cumulative_consumer',
    column: 7,
  },
  {
    name: '入住次数',
    i18nName: 'guest.list.column.checkin_time',
    width: 150,
    sortable: true,
    field: 'checkin_times',
    column: 8,
  },
  {
    name: '订单均价',
    i18nName: 'guest.list.column.arr',
    width: 120,
    sortable: true,
    field: 'avg_reservation_price',
    column: 9,
  },
  {
    name: '间夜数',
    i18nName: 'guest.list.column.nights',
    width: 150,
    sortable: true,
    field: 'total_nights',
    column: 10,
  },
  {
    name: '间夜均价',
    i18nName: 'guest.list.column.adr',
    width: 120,
    sortable: true,
    field: 'avg_night_price',
    column: 11,
  },
  {
    name: '上次入住',
    i18nName: 'guest.list.column.last_stay',
    width: 100,
    sortable: true,
    field: 'last_checkin_time',
    column: 12,
  },
  {
    name: '首次入住',
    i18nName: 'guest.list.column.first_stay',
    width: 100,
    sortable: true,
    field: 'first_checkin_time',
    column: 13,
  },
  { name: '国籍', i18nName: 'guest.list.column.nationality', width: 150, column: 14 },
  { name: '生日', i18nName: 'guest.list.column.birthday', width: 150, column: 15 },
  { name: '备注', i18nName: 'guest.list.column.remarks', width: 150, column: 16 },
  { name: '标签', i18nName: 'word.tag', width: 200, column: 17 },
  { name: '', i18nName: '', width: 100, column: 18, hide: true },
];
